import NewsView from '../../components/views/common/News'

function News() {
	return <NewsView />
}

export default News
